import { render, staticRenderFns } from "./ReLeadMessageButton.vue?vue&type=template&id=a3816ea0&scoped=true"
import script from "./ReLeadMessageButton.vue?vue&type=script&lang=js"
export * from "./ReLeadMessageButton.vue?vue&type=script&lang=js"
import style0 from "./ReLeadMessageButton.vue?vue&type=style&index=0&id=a3816ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3816ea0",
  null
  
)

export default component.exports